import MaterialTable from "material-table";
import {useEffect, useState} from "react";
import './Table.scss';
import {FilterData} from "../../dashboard/shared/Filters/Filters";
import {Loader} from "../../shared/Loeader/Loader";


const calculateWorker: Worker = new Worker(window.location.origin  + '/workers/table-worker.js');


type TableProps = {
    data: Array<any>;
    columns: Array<string>;
    columnNames?: object;
    filters?: Array<FilterData>;
    currencyValues?: Array<string>;
    lengthValues?: Array<string>
}

const Table = ({data, columns, filters, columnNames, currencyValues, lengthValues}: TableProps) => {

    const [tableData, setTableData] = useState<Array<any> | null>(null);
    const [dataColumns, setColumns] = useState<Array<any>>([]);
    const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false);

    useEffect(() => {
        if (!calculateWorker) return;
        calculateWorker.onmessage = ($event: MessageEvent) => {
            if ($event && $event.data) {
                const {type} = $event.data;
                switch (type) {
                    case "mapColumns":
                        setColumns($event.data.data);
                        break;
                    case "getData":
                        setTableData($event.data.data);
                        setIsDataLoaded(true);
                        break;
                }
            }
        };
    }, [calculateWorker]);

    useEffect(() => {
        if (!calculateWorker) return;

        calculateWorker.postMessage({
            type: "mapColumns",
            columns,
            columnNames,
            filters
        });
    }, [columns, filters]);

    useEffect(() => {
        if (!calculateWorker) return;
        setIsDataLoaded(false);
        calculateWorker.postMessage({
            type: "getData",
            data,
            currencyValues,
            lengthValues
        });
    }, [data]);

    return (
        <div className={'chart'} style={{width: '100%'}}>
            <h3>Dane</h3>
            <div style={{maxWidth: "100%"}}>

                {!(isDataLoaded && tableData) ? <Loader/> :
                    <MaterialTable
                        options={{
                            exportButton: true,
                            search: false,
                            showTitle: false,
                            showFirstLastPageButtons: false,
                        }}
                        columns={dataColumns}
                        data={tableData}
                        title="Data"
                    />
                }
            </div>
        </div>
    )
}

export {Table}